import { defineComponent, ref, onMounted, onBeforeUnmount, watch, createElementBlock, openBlock } from 'vue';
import { useElementVisibility, useDocumentVisibility } from './basler-components.es419.js';
import { CtaCanvasRenderer } from './basler-components.es420.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CtaCanvasBackground",
  props: {
    colorMode: { default: "dark" },
    color1: { default: "#743ac2" },
    color2: { default: "#fe185e" },
    usePostProcessing: { type: Boolean, default: false },
    useUnrealBloom: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const color1 = ref(
      props.colorMode == "light" || props.colorMode == "dark" ? "#011C53" : props.colorMode == "dark-purple" ? "#743ac2" : props.color1
    );
    const color2 = ref(
      props.colorMode == "light" || props.colorMode == "dark" ? "#002FA6" : props.colorMode == "dark-purple" ? "#2e185e" : props.color2
    );
    const usePostProcessing = ref(props.usePostProcessing);
    const useUnrealBloom = ref(props.useUnrealBloom);
    const webglcanvas = ref(null);
    let ctaCanvasRenderer = null;
    const wrapperIsVisible = useElementVisibility(webglcanvas);
    const documentVisibility = useDocumentVisibility();
    const onWindowResizeFunction = () => {
      ctaCanvasRenderer?.onResize();
    };
    const cleanupRenderer = () => {
      window.removeEventListener("resize", onWindowResizeFunction);
      if (ctaCanvasRenderer) {
        ctaCanvasRenderer.dispose();
        ctaCanvasRenderer = null;
      }
    };
    onMounted(() => {
      if (webglcanvas.value) {
        ctaCanvasRenderer = new CtaCanvasRenderer({
          color1: color1.value,
          color2: color2.value,
          showDebugControls: false,
          usePostProcessing: usePostProcessing.value,
          useUnrealBloom: useUnrealBloom.value
        });
        ctaCanvasRenderer.init(webglcanvas.value);
        ctaCanvasRenderer.renderLoop();
      }
      window.addEventListener("resize", onWindowResizeFunction, {
        passive: true
      });
    });
    onBeforeUnmount(() => {
      cleanupRenderer();
    });
    watch(
      wrapperIsVisible,
      (newVal) => {
        ctaCanvasRenderer?.setPaused(!newVal);
      },
      { immediate: true, deep: true }
    );
    watch(
      documentVisibility,
      (newVal) => {
        if (newVal === "hidden") {
          ctaCanvasRenderer?.setPaused(true);
        } else if (wrapperIsVisible.value) {
          ctaCanvasRenderer?.setPaused(false);
        }
      },
      { immediate: true, deep: true }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("canvas", {
        class: "cta-canvas-background",
        ref_key: "webglcanvas",
        ref: webglcanvas
      }, null, 512);
    };
  }
});

export { _sfc_main as default };
